import React, { Suspense, useState } from 'react'
import { View } from 'styles/reactnative'

import { CloseOutlined, SearchOutlined } from '@ant-design/icons'
import { Button, DatePicker, Input, Select, Space } from 'antd'
import { PGDepositTableColumn } from './PGDepositTableColumn'

import dayjs from 'dayjs'
import PGTableAPI from './PGTableAPI'

const PGDepositManagement = ({ title, type, group }: any) => {
	const params = new URLSearchParams(window.location.search)
	const idquery = params.get('userid')
	const process = params.get('process')

	const [user_id, setUser_id] = useState<any>(idquery || '')
	const [status, setStatus] = useState<any>(process || '')
	const [startDate, setStartDate] = useState<any>(null)
	const [endDate, setEndDate] = useState<any>(null)
	const [pgProvider, setPgProvider] = useState<any>('')
	const [limit] = useState(50)

	const makeurl = (check, query) => {
		if (check) {
			return `&${query}=${check}`
		} else {
			return ''
		}
	}

	return (
		<View style={{ width: '100%' }}>
			<View
				style={{
					width: '100%',
					padding: 10,
					flexDirection: 'row',
					background: '#fff',
					marginTop: 5,
					marginBottom: 5,
					borderRadius: 10,
					flex: 1,
					justifyContent: 'space-between',
					alignItems: 'center',
				}}>
				<View
					style={{
						flexDirection: 'row',
					}}>
					<Button
						type="primary"
						style={{ marginRight: 10 }}
						onClick={() => {
							setStatus('')
							setUser_id('')
							setPgProvider('')
							setStartDate(null)
							setEndDate(null)
						}}>
						전체보기
					</Button>
					<Select
						value={status}
						onChange={e => {
							setStatus(e)
						}}
						filterOption={true}
						options={[
							{ value: '', label: '진행상태' },
							{ value: 'PENDING', label: '처리대기' },
							{ value: 'APPROVED', label: '승인됨' },
							{ value: 'REJECTED', label: '거절됨' },
						]}
						style={{ marginRight: 10 }}
					/>
					<Select
						value={pgProvider}
						onChange={e => {
							setPgProvider(e)
						}}
						filterOption={true}
						options={[
							{ value: '', label: 'PG사 전체' },
							{ value: 'suprapay', label: 'SUPRAPAY' },
						]}
						style={{ marginRight: 10, minWidth: 120 }}
					/>
					<Space.Compact direction="horizontal">
						<Input
							placeholder="사용자 ID"
							value={user_id}
							onChange={e => {
								setUser_id(e.target.value)
							}}
						/>
						<Button
							onClick={() => {
								setUser_id('')
							}}
							style={{ paddingTop: 0 }}
							size="small">
							{user_id ? <CloseOutlined /> : <SearchOutlined />}
						</Button>
						<Button
							onClick={() => {
								setUser_id('')
							}}
							style={{ paddingTop: 0 }}
							size="small">
							전체
						</Button>
					</Space.Compact>
				</View>

				<Space>
					기간
					<Space.Compact>
						<DatePicker
							onChange={e =>
								setStartDate(
									dayjs(e, 'YYYY-MM-DD').format('YYYY-MM-DD')
								)
							}
							defaultValue={
								startDate
									? dayjs(startDate, 'YYYY-MM-DD')
									: undefined
							}
						/>
						<DatePicker
							onChange={e =>
								setEndDate(
									dayjs(e, 'YYYY-MM-DD').format('YYYY-MM-DD')
								)
							}
							defaultValue={
								endDate
									? dayjs(endDate, 'YYYY-MM-DD')
									: undefined
							}
						/>
					</Space.Compact>
					<Button
						onClick={() => {
							setStartDate(null)
							setEndDate(null)
						}}>
						전체
					</Button>
				</Space>
			</View>

			<Suspense fallback={<View>Loading...</View>}>
				<PGTableAPI
					title={title}
					columns={PGDepositTableColumn}
					usermodal={true}
					className={'plist'}
					height={'default'}
					footer={3}
					width={1400}
					apikey={`/payment/partner?request_type=DEPOSIT&limit=${limit}&offset=0${makeurl(
						user_id,
						'user_id'
					)}${makeurl(status, 'status')}${makeurl(
						pgProvider,
						'pg_provider'
					)}${makeurl(startDate, 'start_date')}${makeurl(endDate, 'end_date')}${makeurl(group, 'group')}`}
				/>
			</Suspense>
		</View>
	)
}

export default React.memo(PGDepositManagement)
